<template>
  <v-dialog
    v-model="dialog"
    width="auto "
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="2" sm="1" md="1" lg="1">
                <color-select v-model="form.task.color" />
              </v-col>
              <v-col cols="10" sm="11" md="5" lg="5">
                <v-text-field
                  label="Job Code *"
                  v-model="form.task.code"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="6" sm="6" md="3" lg="3">
                <v-select
                  label="Label *"
                  v-model="form.task.type"
                  :items="typeList"
                />
              </v-col>
              <v-col cols="6" sm="6" md="3" lg="3">
                <v-text-field
                  label="Enter Custom Label"
                  v-model="form.task.typeCustom"
                  v-show="form.task.type == 'Custom'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <task-combo
                  v-model="src"
                  label="Job Name *"
                  :solo="false"
                  :filter-type="form.task.type ? form.task.type : ''"
                  @keyup="handleChangeName"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.name'),
                      serverSideErrors('Name')
                    )
                  "
                  @blur="$v.form.task.name.$touch()"
                />
              </v-col>
            </v-row>
            <!-- 
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col cols="6">
                    <date-picker
                      v-model="form.task.date"
                      label="Start Date *"
                      :error-messages="
                        [].concat(
                          fieldErrors('form.task.date'),
                          serverSideErrors('Date')
                        )
                      "
                      :max="form.task.endDate"
                      @blur="$v.form.task.date.$touch()"
                      :hide-details="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <time-picker
                      v-model="form.task.time"
                      label="Time *"
                      :error-messages="
                        [].concat(
                          fieldErrors('form.task.time'),
                          serverSideErrors('Time')
                        )
                      "
                      @blur="$v.form.task.time.$touch()"
                    />
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="6">
                <v-row>
                  <v-col cols="6">
                    <date-picker
                      v-model="form.task.endDate"
                      label="End Date *"
                      :error-messages="
                        [].concat(
                          fieldErrors('form.task.endDate'),
                          serverSideErrors('EndDate')
                        )
                      "
                      @blur="$v.form.task.endDate.$touch()"
                      :min="form.task.date"
                      :hide-details="true"
                    />
                  </v-col>
                  <v-col cols="6">
                    <time-picker
                      v-model="form.task.endTime"
                      :min="form.task.time"
                      label="Time *"
                      :error-messages="
                        [].concat(
                          fieldErrors('form.task.endTime'),
                          serverSideErrors('EndTime')
                        )
                      "
                      @blur="$v.form.task.endTime.$touch()"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->

            <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <TypeSelect
                  v-model="form.task.type"
                  label="Type"
                  :error-messages="[].concat(fieldErrors('form.task.type'))"
                  @blur="$v.form.task.type.$touch()"
                />
              </v-col>
            </v-row> -->

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="form.task.description"
                  label="Description"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.description'),
                      serverSideErrors('Description')
                    )
                  "
                  @blur="$v.form.task.description.$touch()"
                  rows="3"
                  auto-grow
                ></v-textarea>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <client-select
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.clientId'),
                      serverSideErrors('ClientId')
                    )
                  "
                  v-model="form.task.clientId"
                  label="Select Client *"
                  @blur="$v.form.task.clientId.$touch()"
                />
              </v-col>

              <!-- <v-col cols="12" sm="12" md="12">
                <v-text-field
                  type="number"
                  v-model="form.task.payRate"
                  label="Pay Rate / Hour"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.payRate'),
                      serverSideErrors('PayRate')
                    )
                  "
                  @blur="$v.form.task.payRate.$touch()"
                />
              </v-col> -->
              <v-col cols="12" sm="12" md="12">
                <user-select
                  v-model="form.userIds"
                  label="Assign To"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.userIds'),
                      serverSideErrors('UserIds')
                    )
                  "
                  @blur="$v.form.userIds.$touch()"
                  :multiple="true"
                />
              </v-col>

              <!-- <v-col cols="12" sm="12" md="12">
                <tags-select
                  v-model="form.task.tags"
                  label="Tags"
                  :filter-word="form.task.type"
                  :error-messages="[].concat(fieldErrors('form.task.tags'))"
                  @blur="$v.form.task.tags.$touch()"
                  :hide-details="false"
                />
              </v-col> -->
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title> Address </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          label="Street"
                          v-model="form.task.addressStreet"
                          :hide-details="true"
                        />
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="City"
                          v-model="form.task.addressCity"
                          :hide-details="true"
                        />
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="State"
                          v-model="form.task.addressState"
                          :hide-details="true"
                        />
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Zip Code"
                          v-model="form.task.addressZipCode"
                          :hide-details="true"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-btn x-small @click="addChangeOrder()">
                  <v-icon>mdi-plus</v-icon>
                  Change Order</v-btn
                >
              </v-col>
              <v-col cols="12" v-show="changeOrders.length > 0">
                <v-sheet elevation="6">
                  <v-tabs
                    next-icon="mdi-arrow-right-bold-box-outline"
                    prev-icon="mdi-arrow-left-bold-box-outline"
                    show-arrows
                    v-model="tabs"
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      v-for="(
                        changeOrder, changeOrderIdx
                      ) in changeOrderReversed"
                      :key="`${changeOrderIdx}_changeOrders_tab`"
                      :href="'#tab-' + changeOrderIdx"
                    >
                      {{ changeOrder.title }}
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tabs">
                    <v-tab-item
                      v-for="(
                        changeOrder, changeOrderIdx
                      ) in changeOrderReversed"
                      :key="`${changeOrderIdx}_changeOrders_content`"
                      :value="'tab-' + changeOrderIdx"
                    >
                      <v-card>
                        <v-card-title>
                          {{ changeOrder.titleTab }}
                          <v-spacer />
                          <v-btn
                            x-small
                            class="mr-2"
                            @click="removeChangeOrder(changeOrderIdx)"
                            ><v-icon>mdi-delete</v-icon> Change order</v-btn
                          >

                          <v-btn x-small @click="addMaterial(changeOrderIdx)"
                            ><v-icon>mdi-plus</v-icon> Material</v-btn
                          >
                        </v-card-title>
                        <v-card-text>
                          <v-card
                            class="mt-2"
                            v-for="(
                              material, materialIdx
                            ) in changeOrder.materials"
                            :key="`${changeOrderIdx}_${materialIdx}_materials`"
                          >
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" lg="5" md="5" sm="5">
                                  <v-text-field
                                    label="Material"
                                    v-model="material.materialName"
                                    :hide-details="true"
                                  >
                                    <v-icon
                                      slot="prepend"
                                      @click="
                                        removeMaterial(
                                          changeOrderIdx,
                                          materialIdx
                                        )
                                      "
                                    >
                                      mdi-delete
                                    </v-icon>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="6" lg="1" md="1" sm="1">
                                  <v-text-field
                                    v-model="material.quantity"
                                    label="Quantity"
                                    :hide-details="true"
                                    type="number"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="6" lg="2" md="2" sm="2">
                                  <v-select
                                    v-model="material.unit"
                                    :items="['ft²', 'Lineal ft']"
                                    label="Unit"
                                    :hide-details="true"
                                  ></v-select>
                                </v-col>
                                <v-col cols="6" lg="1" md="1" sm="1">
                                  <v-text-field
                                    label="Quantity"
                                    v-model="material.quantityPerCase"
                                    type="number"
                                    :hide-details="true"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="6" lg="2" md="2" sm="2">
                                  <v-select
                                    v-model="material.case"
                                    :items="[
                                      'Case',
                                      'Gallon',
                                      'Tube',
                                      'Roll',
                                      'Sausage',
                                      'Custom',
                                    ]"
                                    label="Unit"
                                    :hide-details="true"
                                  ></v-select>
                                </v-col>

                                <v-col cols="6" lg="1" md="1" sm="1">
                                  <v-text-field
                                    v-model="material.hours"
                                    label="Hours"
                                    type="number"
                                    :hide-details="true"
                                  />
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" v-show="item.id">
                <TaskStatusSelect
                  v-model="form.task.status"
                  label="Select Status"
                  :error-messages="
                    [].concat(
                      fieldErrors('form.task.status'),
                      serverSideErrors('Status')
                    )
                  "
                  @blur="$v.form.task.status.$touch()"
                />
              </v-col>
              <v-col cols="12" v-show="form.task.status == 'completed'">
                <date-picker
                  v-model="form.task.dateCompleted"
                  label="Completed at"
                  @blur="$v.form.task.date.$touch()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn @click="viewOrAddFile()" x-small v-if="isEdit"
                  >Add / View Files</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <AttachedFileListDialog
      :show="showAttachFile"
      :item="item"
      object="task"
      @onClosed="clearAttachFile()"
      @onSucceded="refresh()"
    />
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import ClientSelect from "src/components/ClientSelect.vue";
import DatePicker from "src/components/DatePicker.vue";
import UserSelect from "src/components/UserSelect";
import formatterMixin from "@/mixins/formatterMixin";
// import TypeSelect from "components/TypeSelect.vue";
// import TimePicker from "components/TimePicker.vue";
import TaskStatusSelect from "components/TaskStatusSelect";
import ColorSelect from "components/ColorSelect";
import TaskCombo from "components/TaskCombo";
import AttachedFileListDialog from "components/FilesAttachment/AttachedFileListDialog";

const defaultInputs = {
  task: {
    id: "",
    code: "",
    name: "",
    status: "open",
    type: "Labor",
    date: new Date(),
    endDate: new Date(),
    addressStreet: "",
    addressCity: "",
    addressState: "",
    addressZipCode: "",
    time: undefined,
    endTime: undefined,
    description: "",
    clientId: "",
    payRate: 0,
    tags: [],
    color: "#ad1457",
    isTimeClockRunning: false,
    isInvoiced: false,
    isCompleted: false,
    dateCreated: null,
    lastUpdated: null,
    typeCustom: "",
  },
  userIds: [],
};

export default {
  components: {
    AlertMessage,
    ClientSelect,
    DatePicker,
    UserSelect,
    // TypeSelect,
    // TimePicker,
    TaskStatusSelect,
    ColorSelect,
    TaskCombo,
    AttachedFileListDialog,
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
    title: String,
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      userIds: {},
      task: {
        name: {
          required,
        },
        status: {},
        code: { required },
        type: { required },
        date: {},
        endDate: {},
        time: {},
        endTime: {},
        clientId: { required },
        description: {},
        payRate: {},
        tags: {},
        dateCompleted: {},
      },
    },
  },
  validationMessages: {
    form: {
      userIds: { required: "Required" },
      task: {
        dateCompleted: {},
        name: {
          required: "Name required",
        },
        status: {
          required: "Required",
        },
        type: {
          required: "Required",
        },
        date: {
          required: "Required",
        },
        time: {
          required: "Required",
        },
        endTime: {
          required: "Required",
        },
        description: {
          required: "Required",
        },
        clientId: {
          required: "Required",
        },
        payRate: {},
        tags: {},
      },
    },
  },

  data() {
    return {
      tabs: null,
      showDialog: this.show,
      src: null,
      form: {
        ...defaultInputs,
        task: {
          ...defaultInputs.task,
          clientId: this.clientId,
        },
        materials: [],
        changeOrders: [],
      },

      typeOptions: [
        { value: "remote", text: "Remote Support" },
        { value: "onsite", text: "Onsite Support" },
      ],

      statusOptions: [
        { value: "open", text: "Open" },
        { value: "closed", text: "Closed" },
        { value: "complete", text: "Completed" },
      ],

      dialog: false,
      valid: false,
      loading: false,
      showAttachFile: false,
      materials: [],
      changeOrders: [],
      typeList: ["Custom", "PLA", "Prevailing Wage", "Standard", "Union"],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    src(n) {
      if (n) {
        this.form.task.name = typeof n == "string" ? n : n.name;
        if (n && n.name) {
          this.form.task.type = n.type;
        }
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        let userIds = [];
        if (newTask.taskUsers) {
          userIds = newTask.taskUsers.map((user) => user.userId);
        }

        let jobMaterials = newTask.jobMaterials || [];
        jobMaterials = jobMaterials.map((jobMaterial) => {
          return {
            ...jobMaterial,
            hours: jobMaterial.hours / 3600,
          };
        });

        let typeFinal = !this.typeList.includes(newTask.type)
          ? "Custom"
          : newTask.type;
        let typeFinalCustom = typeFinal === "Custom" ? newTask.type : "";

        this.form = {
          task: {
            ..._.pick(newTask, _.keys(defaultInputs.task)),
            ...newTask,
            type: typeFinal,
            typeCustom: typeFinalCustom,
            tags: newTask.categories ? newTask.categories.map((c) => c.id) : [],
            // date: this.momentLocal(newTask.date).format("YYYY-MM-DD"),
            // time: this.formatDatetime(newTask.date).split(" ")[1],
            // endDate: this.momentLocal(newTask.date).format("YYYY-MM-DD"),
            // endTime: this.formatDatetime(newTask.endDate).split(" ")[1],
            // time: this.momentLocal(newTask.date).format('HH:mm'),
          },
          materials: jobMaterials,
          userIds,
        };
        this.src = newTask.name;

        // parse changeOrder here
        let changeOrders = [
          ...new Set(jobMaterials.map((obj) => obj.changeOrderId)),
        ];
        let tempOrders = changeOrders.map((changeOrderIdx) => {
          return {
            id: changeOrderIdx,
            title:
              changeOrderIdx == 1 ? "Original" : `CO #${changeOrderIdx - 1}`,
            titleTab:
              changeOrderIdx == 1
                ? "Original Quote"
                : `Change Order #${changeOrderIdx - 1}`,
            materials: jobMaterials.filter(
              (m) => m.changeOrderId == changeOrderIdx
            ),
          };
        });

        this.changeOrders = tempOrders;

        // sort by change order id, to keep original quote and additional quote tab position
        this.changeOrders.sort(function (a, b) {
          return a.id - b.id;
        });
      } else {
        this.form = {
          ...defaultInputs,
          task: {
            ...defaultInputs.task,
            clientId: this.clientId,
            // date: this.momentLocal().format("YYYY-MM-DD"),
            // time: this.momentLocal().format("HH:mm"),
            // endDate: this.momentLocal().format("YYYY-MM-DD"),
            // endTime: this.momentLocal().add(1, "hour").format("HH:mm"),
          },
          userIds: [this.user.id],
          materials: [],
        };
        // set default change order here
        this.changeOrders = [];
        if (!this.isEdit) {
          this.addChangeOrder();
        }
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      user: (state) => state.account.data.user,
      task: (state) => state.task,
      alert: (state) => state.alert,
    }),
    formTitle() {
      let stuff = this.title ? this.title : "Job";
      return this.isEdit ? `Edit ${stuff}` : `Add ${stuff}`;
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    taskId() {
      return UTIL.gv(this.item, "id", "");
    },
    changeOrderReversed() {
      return [...this.changeOrders];
    },
  },

  methods: {
    ...mapActions("task", ["create", "update"]),
    ...mapActions({
      createTimeClock: "timeclock/createFromTask",
    }),

    handleChangeName(newEntry) {
      if (typeof newEntry === "string") {
        this.form.task.name = newEntry;
      } else if (newEntry && newEntry.name) {
        this.form.task.name = newEntry.name;
        this.form.task.type = newEntry.type;
        console.log(newEntry);
      }
    },

    viewOrAddFile() {
      this.showAttachFile = true;
    },

    clearAttachFile() {
      this.showAttachFile = false;
    },

    refresh() {},

    addMaterial(changeOrderIdx) {
      let newMaterial = {
        taskId: this.item ? this.item.id : null,
        changeOrderId: changeOrderIdx,
        materialName: "",
        quantity: 0,
        quantityPerCase: 0,
        case: "",
        unit: "",
      };

      this.changeOrders[changeOrderIdx].materials.push(newMaterial);
    },

    addChangeOrder() {
      let changeOrderIdx = this.changeOrders.length;
      let title = changeOrderIdx === 0 ? "Original" : `CO #${changeOrderIdx}`;
      let titleTab =
        changeOrderIdx === 0
          ? "Original Quote"
          : `Change Order #${changeOrderIdx}`;

      let firstOrderTab = {
        title: title,
        titleTab: titleTab,
        id: changeOrderIdx + 1,
        materials: [],
      };
      this.changeOrders.push(firstOrderTab);
      this.addMaterial(changeOrderIdx);
    },

    removeMaterial(changeOrderIdx, materialIdx) {
      this.changeOrders[changeOrderIdx].materials.splice(materialIdx, 1);
    },

    removeChangeOrder(changeOrderIdx) {
      if (confirm("Are you sure will delete this change order?")) {
        this.changeOrders.splice(changeOrderIdx, 1);
      }
    },

    initForm() {
      if (this.clientId) {
        let categories = this.optional(this.item, "categories", []) || [];
        this.form = {
          ...this.form,
          task: {
            ...this.form.task,
            clientId: this.clientId,
            time: "00:00:00",
            tags: categories.map((category) => category.id),
          },
        };
      }
    },

    serverSideErrors(field) {
      return UTIL.gv(this.task.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let materials = [];
      for (const changeOrderIdx in this.changeOrders) {
        let changeOrder = this.changeOrders[changeOrderIdx];
        for (const materialIdx in changeOrder.materials) {
          let material = changeOrder.materials[materialIdx];
          delete material.id;
          let totalHourInSecond = parseFloat(material.hours) * 3600;
          materials.push({
            ...material,
            changeOrderId: changeOrder.id,
            hours: totalHourInSecond,
          });
        }
      }

      let typeFinal =
        this.form.task.type == "Custom"
          ? this.form.task.typeCustom
          : this.form.task.type;

      let payload = {
        ...this.form,
        task: {
          ...this.form.task,
          // date: this.momentLocal(
          //   this.form.task.date + ` ` + this.form.task.time
          // ).format('YYYY-MM-DD h:i'),
          // endDate: this.momentLocal(
          //   this.form.task.endDate + ` ` + this.form.task.endTime
          // ).format('YYYY-MM-DD h:i'),
          // isScheduled: false,
          type: typeFinal,
        },
        tags: this.form.task.tags,
        materials: materials,
      };

      if (
        payload.task.status === "open" ||
        payload.task.status === "inprogress"
      ) {
        payload.task.isCompleted = false;
        if (!payload.task.invoiceId) {
          payload.task.isInvoiced = false;
        }
      } else if (payload.task.status === "completed") {
        payload.task.isCompleted = true;
      } else if (payload.task.status === "invoiced") {
        payload.task.isCompleted = true;
        if (payload.task.invoiceId) {
          payload.task.isInvoiced = true;
        }
      } else if (payload.task.status === "canceled") {
        payload.task.isCompleted = false;
        if (!payload.task.invoiceId) {
          payload.task.isInvoiced = false;
        }
      }

      if (this.isEdit) {
        await this.update({
          id: this.taskId,
          ...payload,
        });
      } else {
        delete payload.task.id;
        await this.create(payload);
        if (!this.task.status.error) {
          // await this.createTimeClock({
          //   id: this.task.single.id,
          //   ...payload,
          // });
        }
      }

      if (!this.task.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>